var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanCompleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9V7C2.5 4 4.5 2 7.5 2H17.5C20.5 2 22.5 4 22.5 7V9",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15V17C2.5 20 4.5 22 7.5 22H17.5C20.5 22 22.5 20 22.5 17V15",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 9.25977L12.5 12.3298L17.7599 9.27979",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.7693V12.3193",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.26 6.28957L8.05998 8.0696C7.33998 8.4696 6.73999 9.47959 6.73999 10.3096V13.6996C6.73999 14.5296 7.32998 15.5396 8.05998 15.9396L11.26 17.7196C11.94 18.0996 13.06 18.0996 13.75 17.7196L16.95 15.9396C17.67 15.5396 18.27 14.5296 18.27 13.6996V10.3096C18.27 9.47959 17.68 8.4696 16.95 8.0696L13.75 6.28957C13.06 5.89957 11.94 5.89957 11.26 6.28957Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanCompleteIcon);
export default __webpack_public_path__ + "static/media/care_plan_complete_icon.bc9ccb9c11168700b313615a7ce6bab2.svg";
export { ForwardRef as ReactComponent };